// Structured Data (Schema.org) for SEO

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Junisama Inversiones S.A.S",
  "alternateName": "Junisama",
  "image": "https://junisama.com.co/images/logo.png",
  "@id": "https://junisama.com.co",
  "url": "https://junisama.com.co",
  "telephone": "+573507089584",
  "email": "info@junisama.com.co",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Calle XX # XX-XX", // TODO: Update with actual address
    "addressLocality": "Bogotá", // TODO: Confirm city
    "addressRegion": "Cundinamarca", // TODO: Confirm region
    "postalCode": "110111", // TODO: Update with actual postal code
    "addressCountry": "CO"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 4.7110, // TODO: Update with actual coordinates
    "longitude": -74.0721 // TODO: Update with actual coordinates
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "opens": "08:00",
    "closes": "18:00"
  },
  "sameAs": [
    "https://wa.me/573507089584"
    // TODO: Add Facebook URL if available
    // TODO: Add Instagram URL if available
    // TODO: Add LinkedIn URL if available
  ],
  "priceRange": "$$",
  "description": "Alquiler de unidades sanitarias portátiles para eventos en Colombia. Baños portátiles VIP, estándar, eléctricos, para discapacitados, lavamanos Aquastand, trailers de lujo, operarios certificados y puntos ecológicos. Más de 10 años de experiencia.",
  "areaServed": [
    {
      "@type": "City",
      "name": "Bogotá"
    },
    {
      "@type": "City",
      "name": "Medellín"
    },
    {
      "@type": "Country",
      "name": "Colombia"
    }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Servicios de Baños Portátiles",
    "itemListElement": [
      {
        "@type": "OfferCatalog",
        "name": "Baños Portátiles VIP",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Alquiler de Baños Portátiles VIP"
            }
          }
        ]
      },
      {
        "@type": "OfferCatalog",
        "name": "Baños Portátiles Estándar",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Alquiler de Baños Portátiles Estándar"
            }
          }
        ]
      },
      {
        "@type": "OfferCatalog",
        "name": "Operarios Certificados",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Servicio de Operarios Certificados"
            }
          }
        ]
      }
    ]
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "paymentAccepted": "Cash, Credit Card, Bank Transfer",
  "currenciesAccepted": "COP"
};

export const createServiceSchema = (service: {
  name: string;
  description: string;
  image: string;
  url: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": service.name,
  "provider": {
    "@type": "LocalBusiness",
    "name": "Junisama Inversiones S.A.S",
    "url": "https://junisama.com.co"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Colombia"
  },
  "description": service.description,
  "image": service.image,
  "url": service.url
});

export const breadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const faqSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const productSchema = (product: {
  name: string;
  description: string;
  image: string;
  price?: string;
  availability?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": product.name,
  "description": product.description,
  "image": product.image,
  ...(product.price && {
    "offers": {
      "@type": "Offer",
      "price": product.price,
      "priceCurrency": "COP",
      "availability": product.availability || "https://schema.org/InStock"
    }
  })
});

